<template>
  <q-card class="teamDetailsCard bg-primary text-white">
    <q-card-section>
      <div class="text-h6">{{ team.team_name }}</div>
    </q-card-section>
    <q-card-section v-if="!substituting">
      <div class="text-subtitle2">
        <div
          v-for="(athlete, index2) in team.members"
          :key="`athlete_${index2}`"
        >
          <q-btn
            dense
            flat
            icon="mdi-swap-horizontal"
            v-if="
              marshall &&
              !athlete.playerLabel.includes('Reserve') &&
              !athlete.isSubbed
            "
            @click="
              substituting = true;
              athleteSubstituted = athlete;
            "
          >
            <q-tooltip>Substitute Athlete</q-tooltip>
          </q-btn>
          <q-btn
            dense
            flat
            icon="mdi-close"
            v-if="
              marshall &&
              !athlete.playerLabel.includes('Reserve') &&
              athlete.isSubbed
            "
            @click="unSubstitute(athlete)"
            :loading="unSubstituting.includes(athlete.id)"
          >
            <q-tooltip>Undo Substitution</q-tooltip>
          </q-btn>
          {{ athlete.playerLabel }}: {{ athlete.firstName }}
          {{ athlete.lastName }}
          <span v-if="athlete.isSubbed" style="font-size: 10px">Subbed</span>
          <span v-if="athlete.subbedLabel" style="font-size: 10px"
            >Sub - {{ athlete.subbedLabel }}</span
          >
        </div>
      </div>
    </q-card-section>
    <q-card-section v-if="substituting">
      <div class="row">
        <q-btn
          flat
          icon="mdi-arrow-left"
          dense
          @click="
            substituting = !substituting;
            reserveAthlete = null;
          "
        ></q-btn>
        <div class="col subTitle q-px-sm">
          {{ athleteSubstituted.firstName }} {{ athleteSubstituted.lastName }}
        </div>
      </div>
      <div class="row">
        <assignMember
          class="full-width"
          :id="reserveAthlete"
          :label="`Sub ${athleteSubstituted.playerLabel}`"
          :filterToEvent="event"
          :filterToPlayerLabel="
            JSON.parse(event.playerLabels).filter(
              (pl) => pl.name == athleteSubstituted.playerLabel
            )
          "
          :includeOnlyIDList="
            team.members
              .filter((m) => m.playerLabel.includes('Reserve'))
              .map((v) => v.associationsMembers_id)
          "
          dark
          color="white"
          @changed="
            (val) =>
              updateMember(
                val,
                JSON.parse(event.playerLabels).filter(
                  (pl) => pl.name == athleteSubstituted.playerLabel
                )
              )
          "
        />
      </div>
      <div class="row q-my-sm">
        <div class="col"></div>
        <q-btn
          class="text-white float-right"
          no-caps
          :disable="!reserveAthlete"
          flat
          label="Submit"
          :loading="submitLoading"
          @click="submitSubstitution"
        >
        </q-btn>
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
  import { mapGetters } from "vuex";
  import assignMember from "@/components/users/assignMember.vue";

  export default {
    components: { assignMember },
    props: {
      team: {
        default: null,
      },
      marshall: {
        default: false,
        type: Boolean,
      },
      round: {
        default: null,
      },
    },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        siteCFG: "settings/siteCFG",
        event: "events/current",
      }),
    },
    data: () => ({
      // Subs
      substituting: false,
      athleteSubstituted: null,
      reserveAthlete: null,
      submitLoading: false,
      unSubstituting: [],
    }),
    mounted() {
      this.$store.dispatch("associations/loadMembersForAssociation", {
        id: this.team.associations_id,
        competitions_id: this.$route.params.competitions_id,
      });
    },
    methods: {
      submitSubstitution() {
        this.submitLoading = true;
        let reserveMember = this.team.members.find(
          (m) => m.associationsMembers_id == this.reserveAthlete
        );
        let payload = {
          substitutedTeamMember_id: this.athleteSubstituted.id,
          playerLabel: this.athleteSubstituted.playerLabel,
          team_id: this.team.team_id,
          reserveTeamMember_id: reserveMember.id,
          round_id: this.round.id,
        };

        this.$store
          .dispatch("eventsEntries/teamMemberSub", payload)
          .then((result) => {
            this.submitLoading = false;
            if (result.Result == "Success") {
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
              this.$store.dispatch(
                "eventProgress/loadCurrentRound",
                this.round.id
              );
              this.$store.dispatch(
                "competitions/updateOmega",
                this.$route.params.competitions_id
              );

              this.substituting = false;
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
      },
      unSubstitute(athlete) {
        this.unSubstituting.push(athlete.id);

        let payload = {
          substitutedTeamMember_id: athlete.id,
          playerLabel: athlete.playerLabel,
          team_id: this.team.team_id,
          round_id: this.round.id,
        };

        this.$store
          .dispatch("eventsEntries/teamMemberUnSub", payload)
          .then((result) => {
            this.unSubstituting = this.unSubstituting.filter(
              (id) => id != athlete.id
            );
            if (result.Result == "Success") {
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
              this.$store.dispatch(
                "eventProgress/loadCurrentRound",
                this.round.id
              );
              this.$store.dispatch(
                "competitions/updateOmega",
                this.$route.params.competitions_id
              );
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
      },
      updateMember(val, playerLabel) {
        this.reserveAthlete = val;
      },
    },
  };
</script>

<style  lang="scss">
  .teamDetailsCard {
    width: 400px;

    .subTitle {
      font-weight: bold;
      font-size: 20px;
    }
  }
</style>
